import { useQuery } from "@apollo/client";
import { TASKS_COUNT_QUERY } from "components/Tasks/schema";
import { ALL_TASK_STATUSES } from "components/Tasks/taskStatusFilter";

/**
 *  Get counts for All (every status, including canceled), Overdue, and Completed
 *  tasks, optionally scoped to a single facility.
 */
export const useTaskCountQueries = ({
  tenantId,
  facilityId,
}: {
  tenantId: string | undefined;
  facilityId?: string;
}) => {
  const facilityScope = facilityId ? ` facilityId:${facilityId}` : "";
  const base = `tenantId:${tenantId}${facilityScope}`;

  const allQuery = useQuery(TASKS_COUNT_QUERY, {
    variables: { search: `${base} taskStatus:${ALL_TASK_STATUSES}` },
    skip: !tenantId,
  });

  const overdueQuery = useQuery(TASKS_COUNT_QUERY, {
    variables: { search: `${base} status:OVERDUE` },
    skip: !tenantId,
  });

  const completedQuery = useQuery(TASKS_COUNT_QUERY, {
    variables: { search: `${base} taskStatus:COMPLETED` },
    skip: !tenantId,
  });

  return {
    allQuery,
    overdueQuery,
    completedQuery,
  };
};
